
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic",
      function () {
        return require("private-next-pages/topic/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic"])
      });
    }
  